<template>
    <header class="wrapper__header">
        <a
            :href="exits.lunchables"
            target="_blank"
            v-trackevent:val="'header-logo'"
        >
            <img src="images/logo.png" alt="Lunchables"/>
        </a>
       <p class="wrapper__header__tag">ADVERTISEMENT</p>
    </header>
</template>

<script>
    import CONFIG from '@/config';

  export default {

    name: 'Header',

    data() {

        return {
            exits: {
                lunchables: CONFIG.settings.exits.lunchables
            }
        };
    }
  }
</script>

<style scoped lang="scss">
    .wrapper__header {
        color: #000000;
        font-family: 'Open Sans', sans-serif;
        font-weight: bold;
        font-size: 14px;
        height: 50px;
        position: absolute;
        text-align: center;
        top: 6px;
        width: 100%;

        &__tag {
            top: 20px;
            right: 10px;
            position: absolute;
        }
    }
</style>
